import React, { useRef } from "react";
import { Modal, Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { verifyOtp, resendOtp } from "../../redux/actions/auth"

// Validation schema
const schema = yup.object({
    otp: yup
        .string()
        .required("OTP is required")
        .matches(/^[0-9]{4}$/, "OTP must be 4 digits"),
});

const EnterOtp = ({ show, onHide, openResetPassword, email, userId }) => {
    const dispatch = useDispatch();
    const inputRefs = useRef([]);

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: { otp: "" },
        mode: "onBlur",
    });

    const handleChange = (value, index) => {
        if (/^[0-9]?$/.test(value)) {
            const otpArray = getValues("otp").padEnd(4, " ").split("");
            otpArray[index] = value;
            const otpValue = otpArray.join("").trim();
            setValue("otp", otpValue);
            if (value && index < 3) inputRefs.current[index + 1].focus();
        }
    };

    const handlePaste = (e, index) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4);
        if (pastedData.length === 4) {
            setValue("otp", pastedData);
            inputRefs.current[3].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !getValues("otp")[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const onSubmit = async (data) => {
        try {
            const payload = { id: userId, otp: data.otp };
            const response = await dispatch(verifyOtp(payload)).unwrap();
            toast.success("OTP verified successfully!");
            onHide();
            setValue("otp", "");
        } catch (error) {
            toast.error(error?.message || "Invalid OTP. Please try again.");
        }
    };

    const handleResendOtp = async () => {
        try {
            const response = await dispatch(resendOtp({ id: userId })).unwrap();
            toast.success("OTP sent successfully!");
            setValue("otp", "");
        } catch (error) {
            toast.error(error?.message || "Failed to resend OTP");
        }
    };

    // const onSubmit = async (data) => {
    //     try {
    //         const res = await dispatch(verifyOtp({ otp: data.otp })); // fixed syntax
    //         if (res.success) {
    //             toast.success("OTP verified successfully!");
    //             onHide();            // Close Enter OTP modal
    //             openResetPassword(); // Open Reset Password modal
    //         } else {
    //             toast.error(res.message || "Invalid OTP");
    //         }
    //     } catch (err) {
    //         toast.error(err.message || "Something went wrong");
    //     }
    // };


    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="border-0" />
            <Modal.Body className="pt-0">
                <div className="commn-modal-signin">
                    <h2>Enter OTP</h2>
                    <p>Please enter the 4-digit OTP sent to your {email}</p>

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Controller
                            name="otp"
                            control={control}
                            render={({ field }) => (
                                <>
                                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "10px" }}>
                                        {[0, 1, 2, 3].map((index) => (
                                            <input
                                                key={index}
                                                type="text"
                                                maxLength="1"
                                                value={field.value[index] || ""}
                                                onChange={(e) => handleChange(e.target.value, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                onPaste={(e) => handlePaste(e, index)}
                                                ref={(el) => (inputRefs.current[index] = el)}
                                                style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    textAlign: "center",
                                                    fontSize: "24px",
                                                    borderRadius: "8px",
                                                    border: "1px solid #ced4da",
                                                }}
                                            />
                                        ))}
                                    </div>
                                    {errors.otp && (
                                        <p className="text-danger" style={{ textAlign: "left", marginBottom: "10px" }}>
                                            {errors.otp.message}
                                        </p>
                                    )}
                                </>
                            )}
                        />

                        <div className="d-grid gap-2">
                            <button type="submit" className="btn btn-primary">
                                Verify Otp
                            </button>
                        </div>

                        <div className="bottom-sign-txt mt-3 text-center">
                            Didn't receive OTP?{" "}
                            <button
                                type="button"
                                className="link-like"
                                onClick={handleResendOtp}
                                style={{ background: "none", border: "none", color: "#000", cursor: "pointer", padding: 0 }}
                            >
                                Resend OTP
                            </button>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default EnterOtp;
